import React from 'react';
import { SmartTagsTextInputLayoutProps } from 'ui-builder';
import useFeatureToggleService from 'feature-toggle';
import BaseTagsInputLayout from './BaseTagsInputLayout';

export default function SmartTagsTextInputLayout(props: SmartTagsTextInputLayoutProps) {
  const { isShadcnUiEnabled } = useFeatureToggleService();

  return (
    <BaseTagsInputLayout {...props} useShadcnLayout={isShadcnUiEnabled()} />
  );
}
